import { module as BaseModule } from 'modujs'

import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import { gsap } from 'gsap'

import { Observer } from 'gsap/Observer'

gsap.registerPlugin(Observer)

import 'swiper/css' //eslint-disable-line

export default class extends BaseModule {
  init() {
    const slider = this.el.querySelector('[data-slider]')
    const params = {
      modules: [Navigation],
      draggable: false,
      slidesPerView: 1,
      grabCursor: false,
      loop: true,

      navigation: {
        nextEl: this.el,
      },
    }

    this.swiper = new Swiper(slider, params)
    this.follower = document.querySelector('.swiper-next')

    const xTo = gsap.quickTo(this.follower, 'x', { duration: 0.1, ease: 'power3' })
    const yTo = gsap.quickTo(this.follower, 'y', { duration: 0.1, ease: 'power3' })
    this.observer = Observer.create({
      type: 'pointer',
      onMove: () => {
        if (!this.isHovering) return
        if (window.innerWidth <= 900) return
        const { x, y } = this.observer

        if (!this.firstMove) {
          this.firstMove = true
          gsap.set(this.follower, { x, y })
          return
        }
        xTo(x)
        yTo(y)
      },
    })

    this.el.addEventListener('mouseenter', () => {
      this.follower.style.display = 'block'
      this.isHovering = true
      document.body.classList.add('no-cursor')
    })
    this.el.addEventListener('mouseleave', () => {
      this.follower.style.display = 'none'
      this.isHovering = false
      document.body.classList.remove('no-cursor')
    })
  }
}
